<template>
  <div class="flex w-[280px] flex-shrink-0 flex-col self-start bg-white p-4 md:w-[378px]">
    <div class="flex flex-col gap-[10px]">
      <!-- レビュー本文 -->
      <p ref="voiceRef" :class="['content-text transition-all', { 'line-clamp-4': isLineClamp4 }]">{{ voice.content }}</p>
      <!-- ユーザー情報 + Show more ボタン -->
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-2">
          <img alt="" class="h-6 w-6" src="@/assets/icon/account_circle.svg" />
          <p class="supplement-text">{{ voice.supplement }}</p>
        </div>
        <button v-if="shouldShowReadMore" class="cursor-pointer text-xs text-gold1 underline" @click="isExpanded = !isExpanded">
          <span>{{ isExpanded ? closeText : readMoreText }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { CustomerVoiceViewModel } from '@/models/customerVoice';

/** 短縮表示する高さの閾値（4行 × 24px line-height = 96px） */
const RENDER_HEIGHT = 96;

interface Props {
  voice: CustomerVoiceViewModel;
  closeText?: string;
  readMoreText?: string;
}

withDefaults(defineProps<Props>(), {
  closeText: 'Close',
  readMoreText: 'Show more',
});

/** お客様の声の Ref を格納する */
const voiceRef = ref<HTMLElement>();

/** 「続きを読む」を押した後、全文表示されているかどうかのフラグ */
const isExpanded = ref(false);

/** 「続きを読む」を表示するかどうかのフラグ */
const shouldShowReadMore = ref(false);

/**
 * お客様の声を4行でカットするかどうかを判定する
 */
const isLineClamp4 = computed<boolean>(() => {
  if (!shouldShowReadMore.value) return false;
  if (isExpanded.value) return false;
  return true;
});

/**
 * マウント後に高さを計算して「続きを読む」を表示するかどうかを判定する
 **/
onMounted(() => {
  nextTick(() => {
    if (!voiceRef.value) return;
    if (voiceRef.value.scrollHeight > RENDER_HEIGHT) {
      shouldShowReadMore.value = true;
    }
  });
});
</script>

<style lang="scss" scoped>
.supplement-text {
  color: #756e66;
  font-family: Spectral, serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}
.content-text {
  color: #756e66;
  font-family: Spectral, serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
